import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, map } from "rxjs";
import { ConvivaApi } from "src/app/conviva-api";
import { DefaultResponse } from "../models/DefaultResponse";

@Injectable({
  providedIn: 'root'
})

export class TipoEnsinoService {
  private api = ConvivaApi;

  constructor(
    private http: HttpClient,
    private router: Router) { }

  public getTiposEnsinos(codigoDiretoria: number, codigoEscola: number): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.TipoEnsino.getTipoEnsinos}?codigoDiretoria=${codigoDiretoria}&codigoEscola=${codigoEscola}`)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getTipoEnsinos(): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.TipoEnsino.getTipoEnsinos}`)
      .pipe(map((response: DefaultResponse) => response));
  }

}
